/**
 * Gestion des messages FR des pages d'erreurs
 */

module.exports = {

    default: {
        title: 'Oops !',
        subtitle: 'The page you\'re looking for can\'t be found!',
        description: 'This page has probably been deleted or never existed.',
        button: {
            home: {
                label: 'Back to the home page'
            },
            contact: {
                label: 'Contact us'
            }
        }
    },
    404: {
        title: 'Page not found',
        message: 'The page you are trying to access does not exist or has been removed.'
    }

};
